module.exports = {
	"id": "EE",
	"name": "Estonia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.024414,
			"5": 0.016276,
			"6": 0.048828,
			"7": null,
			"8": null,
			"9": 0.016276,
			"10": 0.008138,
			"11": 0.024414,
			"12": 0.008138,
			"13": null,
			"14": 0.032552,
			"15": 0.016276,
			"16": 0.032552,
			"17": 0.024414,
			"18": 0.056966,
			"19": 0.024414,
			"20": 0.024414,
			"21": 0.04069,
			"22": 0.032552,
			"23": 0.04069,
			"24": 0.024414,
			"25": 0.04069,
			"26": 0.056966,
			"27": 0.016276,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.024414,
			"32": null,
			"33": 0.024414,
			"34": 0.04069,
			"35": 0.04069,
			"36": 0.04069,
			"37": 0.024414,
			"38": 0.065104,
			"39": 0.073242,
			"40": 0.056966,
			"41": 0.048828,
			"42": 0.16276,
			"43": 0.219726,
			"44": 0.154622,
			"45": 0.065104,
			"46": 0.065104,
			"47": 0.065104,
			"48": 0.097656,
			"49": 1.757808,
			"50": 0.20345,
			"51": 0.862628,
			"52": 0.602212,
			"53": 32.006754,
			"54": 8.894834,
			"55": 0.130208,
			"56": 0.04069,
			"57": null
		},
		"firefox": {
			"2": 0.04069,
			"3": 0.04069,
			"4": 0.016276,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.016276,
			"11": 0.016276,
			"12": 0.024414,
			"13": 0.016276,
			"14": 0.008138,
			"15": null,
			"16": 0.024414,
			"17": 0.04069,
			"18": null,
			"19": 0.008138,
			"20": 0.016276,
			"21": 0.016276,
			"22": null,
			"23": null,
			"24": 0.032552,
			"25": null,
			"26": 0.008138,
			"27": null,
			"28": 0.016276,
			"29": 0.065104,
			"30": 0.008138,
			"31": 0.056966,
			"32": 0.016276,
			"33": 0.04069,
			"34": 0.04069,
			"35": 0.024414,
			"36": 0.04069,
			"37": 0.024414,
			"38": 0.170898,
			"39": 0.04069,
			"40": 0.024414,
			"41": 0.04069,
			"42": 0.113932,
			"43": 0.537108,
			"44": 0.056966,
			"45": 0.333658,
			"46": 0.105794,
			"47": 1.26139,
			"48": 0.634764,
			"49": 11.100232,
			"50": 0.154622,
			"51": 0.008138,
			"52": null,
			"3.5": 0.097656,
			"3.6": 0.292968
		},
		"opera": {
			"9": null,
			"11": 0.008138,
			"12": 0.154622,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.008138,
			"20": 0.016276,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.008138,
			"25": 0.024414,
			"26": null,
			"27": 0.048828,
			"28": null,
			"29": 0.008138,
			"30": 0.008138,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.065104,
			"37": 0.024414,
			"38": 0.12207,
			"39": 0.04069,
			"40": 1.025388,
			"41": 0.138346,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": 0.008138,
			"10.6": 0.032552,
			"11.1": 0.016276,
			"11.5": 0.032552,
			"11.6": 0.089518,
			"12.1": 0.398762
		},
		"safari": {
			"0": null,
			"4": 0.024414,
			"5": 0.12207,
			"6": 0.016276,
			"7": 0.024414,
			"8": 0.236002,
			"9": 0.28483,
			"10": 2.327468,
			"3.1": null,
			"3.2": 0.016276,
			"5.1": 0.097656,
			"6.1": 0.089518,
			"7.1": 0.008138,
			"9.1": 1.570634
		},
		"ios_saf": {
			"8": 0,
			"10": 3.39653442215,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0915326724604,
			"8.1-8.4": 0.169102733868,
			"9.0-9.2": 0.0806728638634,
			"9.3": 1.23077830766
		},
		"android": {
			"3": 0,
			"4": 0.015130255814,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00189128197674,
			"4.1": 0.054576994186,
			"4.2-4.3": 0.136442485465,
			"4.4": 0.312872075581,
			"4.4.3-4.4.4": 0.315573906977
		},
		"ie": {
			"6": null,
			"7": 0.00816427987083,
			"8": 0.1959427169,
			"9": 0.122464198062,
			"10": 0.1959427169,
			"11": 7.06210208827,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0147749019281,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000410413942448
		},
		"edge": {
			"12": 0.097656,
			"13": 0.455728,
			"14": 1.481116
		},
		"ie_mob": {
			"10": 0.0587763380282,
			"11": 0.239303661972
		},
		"bb": {
			"7": 0.001863,
			"10": null
		},
		"samsung": {
			"0": 2.125683
		},
		"and_uc": {
			"0": 0.040986
		},
		"op_mini": {
			"0": 0.199059684129
		},
		"and_chr": {
			"0": 10.667308
		},
		"and_ff": {
			"0": 0.033534
		}
	},
	"total": 97.913819
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/EE.json
 ** module id = 513
 ** module chunks = 0
 **/